export const CanvasOptions = () => (
    <div className="flex flex-col">
        <div className="flex flex-col">

        </div>
    </div>
);